var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEpgLoadingMobile = function SvgEpgLoadingMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 640,
    fill: "none",
    viewBox: "0 0 360 640"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 298,
    fill: "#1A1A1A",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 48,
    x: 104,
    y: 298,
    fill: "#1A1A1A",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 498,
    fill: "#1A1A1A",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 48,
    x: 104,
    y: 498,
    fill: "#1A1A1A",
    rx: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 348,
    fill: "#1A1A1A",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 48,
    x: 104,
    y: 348,
    fill: "#1A1A1A",
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 448,
    fill: "#1A1A1A",
    rx: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 48,
    x: 104,
    y: 448,
    fill: "#1A1A1A",
    rx: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 548,
    fill: "#1A1A1A",
    rx: 2
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 48,
    x: 104,
    y: 548,
    fill: "#1A1A1A",
    rx: 2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 398,
    fill: "#1A1A1A",
    rx: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 48,
    x: 104,
    y: 398,
    fill: "#1A1A1A",
    rx: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 598,
    fill: "#1A1A1A",
    rx: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 48,
    x: 104,
    y: 598,
    fill: "#1A1A1A",
    rx: 2
  })));
};
export default SvgEpgLoadingMobile;